import { Portal } from '@mui/material';
import type { PropsWithChildren } from 'react';

type MobiAppBarActionProps = PropsWithChildren;

export const MobiAppBarAction: React.FC<MobiAppBarActionProps> = (props) => {
  const { children } = props;

  const dom = document.getElementById('appbar-action');
  if (dom) {
    return <Portal container={() => dom}>{children}</Portal>;
  }
};
